import createLogger from '@techstyle/debug';

export default createLogger('~/techstyle-shared/react-intl');
